module.exports = {
	"VERSION": "0.68.1",
	"NUMERIC_VERSION": 0.6801,
	"BUILD_DATE": "20211011_05h18"
}
;